import type { OfferTone } from '@/entities/order';

/** CSS fill for a tone — a design-token reference, resolved by the browser. */
export function toneFill(tone: OfferTone): string {
  return `var(--offer-${tone})`;
}

/** Legible ink on top of {@link toneFill} (the amber fills are light). */
export function toneInk(tone: OfferTone): string {
  return tone === 'amber' || tone === 'amber-soft'
    ? 'var(--offer-on-light)'
    : 'var(--offer-on-dark)';
}

/**
 * The tone as a concrete colour string. Map vector layers (ymaps3 features,
 * Leaflet polylines) draw to canvas/SVG attributes where `var(--…)` is not
 * understood, so they need the resolved value. Falls back to a neutral named
 * colour when the stylesheet is unavailable (SSR, jsdom).
 */
export function resolveToneColor(tone: OfferTone): string {
  if (typeof document === 'undefined') return 'gray';
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--offer-${tone}`)
    .trim();
  return value || 'gray';
}
